import { Component, OnInit, Input, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'app/services/auth/auth.service';
import { ThemeService } from 'app/services/theme.service';
import { LayoutService } from 'app/services/layout.service';
import { UserProfileService } from 'app/services/auth/user-profile.service';
import { CountryLanguageService } from 'app/services/country-language.service';
import { HcpTypeService } from 'app/services/hcp-type.service';
import { ConfigService } from 'app/services/config.service';

@Component({
    selector: 'app-header-side',
    templateUrl: './header-side.template.html',
    styleUrls: ['./header-side.component.scss'],
})
export class HeaderSideComponent implements OnInit {
    @Input() notificPanel;

    public availableLangs = this.countryLanguageService.getCountryLanguage();
    currentLang;

    public photoURL: string;
    public market: string;
    public hcpTypes$;
    public showMarkets = false;
    public egretThemes;
    public layoutConf: any = {};
    constructor(
        public configService: ConfigService,
        private themeService: ThemeService,
        private layout: LayoutService,
        public translate: TranslateService,
        private authService: AuthService,
        private userProfileService: UserProfileService,
        private countryLanguageService: CountryLanguageService,
        private hcpTypeService: HcpTypeService
    ) {
        this.layoutConf = this.layout.layoutConf;
    }

    ngOnInit() {
        this.setDefaults();
        this.hcpTypes$ = this.hcpTypeService.getHcpTypes();
        this.egretThemes = this.themeService.egretThemes;
        this.layoutConf = this.layout.layoutConf;
    }

    setDefaults() {
        if (this.configService.userProfile.userRole === 'Super Admin') {
            this.showMarkets = true;
        }
        this.market = this.configService.userProfile.market;
        this.photoURL = this.configService.userProfile.photoURL;
        this.currentLang = this.countryLanguageService.getCurrentLanguage(this.configService.userProfile);
        this.translate.use(this.currentLang.code);
    }

    updateMarket(market) {
        if (this.configService.userProfile.userRole === 'Super Admin') {
            this.configService.userProfile.market = market.name;
            this.userProfileService.updateUserProfile(this.configService.userProfile);
        }
    }

    updateHcpType(hcpType) {
        if (this.configService.userProfile.userRole === 'Super Admin') {
            this.configService.userProfile.hcpType = hcpType.name;
            this.userProfileService.updateUserProfile(this.configService.userProfile);
        }
    }

    setLang(lng) {
        this.currentLang = lng;
        this.translate.use(lng.code);
    }

    changeTheme() {
        // this.themeService.changeTheme(theme);
    }

    toggleNotific() {
        this.notificPanel.toggle();
    }

    toggleSidenav() {
        if (this.layoutConf.sidebarStyle === 'closed') {
            return this.layout.publishLayoutChange({
                sidebarStyle: 'full',
            });
        }
        this.layout.publishLayoutChange({
            sidebarStyle: 'closed',
        });
    }

    toggleCollapse() {
        // compact --> full
        if (this.layoutConf.sidebarStyle === 'compact') {
            return this.layout.publishLayoutChange(
                {
                    sidebarStyle: 'full',
                    sidebarCompactToggle: false,
                },
                { transitionClass: true }
            );
        }

        // * --> compact
        this.layout.publishLayoutChange(
            {
                sidebarStyle: 'compact',
                sidebarCompactToggle: true,
            },
            { transitionClass: true }
        );
    }

    onSearch() {
        //   console.log(e)
    }

    signOut() {
        this.authService.signOut();
    }
}
